(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-scratch/assets/javascripts/components/canvas-wrapper-leia.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-scratch/assets/javascripts/components/canvas-wrapper-leia.js');
"use strict";

const falcon = svs.ticketgames.falconBridge.falcon;
const HostChannel = svs.ticketgames.falconBridge.HostChannel;
const TopBar = svs.ticketgames.ticketScratch.components.topBar.TopBar;
const {
  LoaderTicket,
  TicketIdPopper
} = svs.ticketgames.ticketScratch.components;
const {
  hostKey,
  bridgeLocation
} = svs.falconBridge && svs.falconBridge.data.environment || {};
const {
  VOUCHER,
  WEB
} = svs.ticketgames.gameHandler.constants.leia.lotteryChannel;
const minimumHeightDefault = svs.ticketgames.gameHandler.constants.leia.gameConfig.default.minimumHeight;
const logger = new svs.core.log.Logger('component:ticket-scratch-leia');
class CanvasWrapperLEIA extends React.Component {
  constructor(props) {
    super(props);
    this.calculateSize = this.calculateSize.bind(this);
    this.onResizeTicket = this.onResizeTicket.bind(this);
    this.validateVoucherCode = this.validateVoucherCode.bind(this);
    this.getVoucherCode = this.getVoucherCode.bind(this);
    this.iframeContainer = React.createRef();
    this.overlayRef = React.createRef();
    this.topBarRef = React.createRef();
    this.canvasContainerRef = React.createRef();
    this.lazyOnResizeTicket = null;
  }
  componentDidMount() {
    this.initGame();
    this.lazyOnResizeTicket = _.debounce(this.onResizeTicket, 50);
    window.addEventListener('resize', this.lazyOnResizeTicket);
  }

  onResizeTicket() {
    const {
      onFullscreenChange
    } = this.props;
    if (!this.iframeContainer.current) {
      return null;
    }
    const {
      height,
      width,
      topBarHeight
    } = this.calculateSize();
    this.iframeContainer.current.style.height = "".concat(height, "px");
    this.iframeContainer.current.style.width = "".concat(width, "px");
    this.canvasContainerRef.current.style.height = "".concat(height - topBarHeight, "px");
    this.canvasContainerRef.current.style.width = "".concat(width, "px");
    this.canvasContainerRef.current.style.position = "relative";
    if (this.topBarRef.current) {
      this.overlayRef.current.style.height = "".concat(height - topBarHeight, "px");
      this.overlayRef.current.style.width = "".concat(width, "px");
      this.topBarRef.current.style.height = "".concat(topBarHeight, "px");
      this.topBarRef.current.style.width = "".concat(width, "px");
    }
    onFullscreenChange && onFullscreenChange(this.getGameAreaHeight());
  }

  componentWillReceiveProps(newProps) {
    const {
      gameResult,
      isLoading
    } = newProps;
    if (!isLoading) {
      setTimeout(() => {
        this.onResizeTicket();
      }, 0);
    }
    if (gameResult) {
      this.onResizeTicket();
    }
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.lazyOnResizeTicket);
  }
  async getVoucherCode(voucherCode) {
    const options = {
      method: 'GET',
      path: "/voucher/5/getvoucher?voucherId=".concat(voucherCode.toUpperCase())
    };
    const {
      response
    } = await svs.core.jupiter.callAsync(options);
    if (response.state !== 'ACTIVE') {
      throw new Error('inactive voucherCode');
    }
    return response;
  }
  async validateVoucherCode(voucherCode) {
    try {
      await this.getVoucherCode(voucherCode);
    } catch (e) {
      logger.warn("Failed to validate voucherCode: ".concat(e.message));
      throw new Error();
    }
  }
  async initGame() {
    const {
      demo,
      wagerId,
      isPending,
      voucherCode,
      ticketInfo,
      onFullscreenChange,
      onClose
    } = this.props;
    let {
      skinId
    } = this.props;
    skinId = !(ticketInfo !== null && ticketInfo !== void 0 && ticketInfo.defaultSkin) && skinId ? skinId : 1;
    const hostChannel = new HostChannel({
      type: ticketInfo.gameEngineCode,
      name: ticketInfo.type,
      listener: this.props.ticketDispatcher.handleResponse
    });
    const gameMode = demo ? 'DEMO' : 'NORMAL';
    if (voucherCode) {
      try {
        await this.validateVoucherCode(voucherCode);
      } catch (e) {
        svs.tur.apierrors.showErrorMessage({
          onConfirm: onClose,
          response: 0
        });
        return;
      }
    }
    falcon.openGame({
      hostChannel,
      bridgeLocation,
      parentNode: this.canvasContainerRef.current,
      crossDomain: {
        hostKey,
        authorizedHosts: [window.location.host]
      },
      gameSpecificParameters: {
        voucherId: voucherCode,
        skinId,
        lockProgress: svs.core.userSession.hasRole(svs.core.userSession.roles.CUSTOMERSERVICE)
      },
      betId: isPending || voucherCode ? null : parseInt(wagerId, 10),
      lotteryChannel: voucherCode ? VOUCHER : WEB,
      skipRules: false,
      soundEnabled: ticketInfo.hasSound && ticketInfo.hasSoundDefaultOn,
      gameMode,
      theme: ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.theme
    });
    const {
      height,
      width,
      topBarHeight
    } = this.calculateSize();
    this.canvasContainerRef.current.style.height = "".concat(height - topBarHeight, "px");
    this.canvasContainerRef.current.style.width = "".concat(width, "px");
    this.canvasContainerRef.current.style.position = "relative";
    onFullscreenChange && onFullscreenChange(this.getGameAreaHeight());
  }
  calculateTopBarHeight() {
    if (this.topBarRef.current) {
      return this.topBarRef.current.offsetHeight;
    }
    return 0;
  }
  getSurroundingElementsHeights() {
    var _document$querySelect, _document$querySelect2;
    return {
      topBarHeight: this.calculateTopBarHeight(),
      menuHeight: ((_document$querySelect = document.querySelector('.js-fixed-top-content')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.getBoundingClientRect().height) || 0,
      accountBalanceBarHeight: ((_document$querySelect2 = document.querySelector('.account-balance-bar')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.offsetHeight) || 0
    };
  }
  getGameAreaHeight() {
    const {
      topBarHeight,
      menuHeight,
      accountBalanceBarHeight
    } = this.getSurroundingElementsHeights();
    return window.innerHeight - (svs.core.detect.breakpoint.greaterThan('md') ? menuHeight : accountBalanceBarHeight) - topBarHeight;
  }
  calculateSize() {
    const {
      topBarHeight,
      menuHeight,
      accountBalanceBarHeight
    } = this.getSurroundingElementsHeights();
    const {
      isFullscreen,
      ticketInfo
    } = this.props;
    const {
      height,
      width,
      containHeight,
      margin,
      minHeight
    } = ticketInfo;
    const {
      innerWidth,
      innerHeight
    } = window;
    const aspectRatio = height / width; 
    const screenAspectRatio = innerHeight / innerWidth; 

    if (isFullscreen) {
      const minimumHeight = parseInt(minHeight, 10) || minimumHeightDefault;
      const calcHeight = innerHeight - (svs.core.detect.breakpoint.greaterThan('md') ? menuHeight : accountBalanceBarHeight);
      const height = Math.max(calcHeight, minimumHeight + topBarHeight);
      const gameAreaHeight = this.getGameAreaHeight();
      const extraMargin = minimumHeight > gameAreaHeight ? parseInt(margin, 10) * 2 : 0;
      return {
        height,
        width: innerWidth - extraMargin,
        topBarHeight
      };
    }
    if (containHeight && containHeight > innerHeight && aspectRatio > screenAspectRatio) {
      const newHeight = innerHeight - menuHeight - margin * 2;
      const newWidth = newHeight / aspectRatio;
      return {
        height: newHeight + topBarHeight,
        width: newWidth,
        topBarHeight
      };
    }
    const newWidth = Math.min(innerWidth - margin * 2, width);
    const newHeight = newWidth * aspectRatio;
    return {
      height: newHeight + topBarHeight,
      width: newWidth,
      topBarHeight
    };
  }
  render() {
    var _ticketInfo$skins;
    const {
      onClose,
      ticketInfo,
      ticketDispatcher,
      ticketNumber,
      isLoading,
      demo,
      skinId,
      isFullscreen,
      wagerId,
      betId
    } = this.props;
    const {
      hasSound,
      idPlacement
    } = ticketInfo;
    const id = parseInt(wagerId, 10);
    const hasTicketNumber = Boolean(ticketNumber && typeof parseInt(ticketNumber, 10) === 'number' && ticketNumber < 32);
    const containerStyle = this.calculateSize();
    return React.createElement("div", {
      className: "relative",
      id: "canvasWrapper",
      ref: this.iframeContainer,
      style: containerStyle
    }, React.createElement("div", {
      className: "top-bar-container"
    }, React.createElement(TopBar, {
      demo: demo,
      gameHasSound: hasSound,
      onClose: onClose,
      ref: {
        topBarRef: this.topBarRef,
        overlayRef: this.overlayRef
      },
      size: containerStyle,
      ticketDispatcher: ticketDispatcher,
      ticketInfo: ticketInfo
    })), isLoading && React.createElement(LoaderTicket, {
      image: !isFullscreen && ((_ticketInfo$skins = ticketInfo.skins[skinId - 1]) === null || _ticketInfo$skins === void 0 ? void 0 : _ticketInfo$skins.image)
    }), React.createElement("div", {
      hidden: isLoading,
      id: "canvasContainer",
      ref: this.canvasContainerRef
    }, !isLoading && hasTicketNumber && React.createElement("div", {
      className: "ticket-number absolute"
    }, ticketNumber)), !isLoading && React.createElement(TicketIdPopper, {
      demo: demo,
      hasTicketNumber: hasTicketNumber,
      id: betId || id,
      isFullscreen: isFullscreen,
      placement: idPlacement,
      refEl: this.canvasContainerRef,
      ticketDispatcher: ticketDispatcher
    }));
  }
}
setGlobal('svs.ticketgames.ticketScratch.components.CanvasWrapperLEIA', CanvasWrapperLEIA);

 })(window);